/* One cart attribute shared by the page and drawer. Never write order notes. */
(() => {
  if (customElements.get('invoice-request')) return;
  const key = 'Invoice requested';
  let value;
  let queue = Promise.resolve();
  let replay = false;
  let submitting = false;
  const widgets = () => document.querySelectorAll('invoice-request');
  const sync = () => widgets().forEach(widget => {
    widget.querySelector('[data-invoice-checkbox]').checked = value === 'Yes';
    widget.querySelector('[data-invoice-checkbox]').disabled = submitting;
    widget.querySelector('[data-invoice-value]').value = value;
  });
  const showError = visible => widgets().forEach(widget => {
    widget.querySelector('[data-invoice-error]').hidden = !visible;
    widget.querySelector('[data-invoice-checkbox]').setAttribute('aria-invalid', String(visible));
  });
  const save = () => {
    const snapshot = value;
    const operation = queue.catch(() => {}).then(async () => {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: { [key]: snapshot } })
      });
      if (!response.ok) throw new Error('Invoice preference could not be saved');
      const cart = await response.json();
      if (cart.attributes?.[key] !== snapshot) throw new Error('Invoice preference was not confirmed');
    });
    queue = operation;
    operation.then(() => showError(false), () => showError(true));
    return operation;
  };
  customElements.define('invoice-request', class extends HTMLElement {
    connectedCallback() {
      if (value === undefined) value = this.dataset.value === 'Yes' ? 'Yes' : 'No';
      sync();
      this.controller?.abort();
      this.controller = new AbortController();
      this.querySelector('[data-invoice-checkbox]').addEventListener('change', event => {
        value = event.target.checked ? 'Yes' : 'No';
        sync();
        save();
      }, { signal: this.controller.signal });
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
  document.addEventListener('submit', async event => {
    if (replay || event.defaultPrevented || !event.submitter?.matches('button[name="checkout"]')) return;
    const container = event.submitter.closest('.cart__details');
    if (!container?.querySelector('invoice-request')) return;
    // Let the existing terms component handle its own validation and warning.
    const terms = container.querySelector('terms-checkbox input[type="checkbox"]');
    if (terms && !terms.checked) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (submitting) return;
    submitting = true;
    sync();
    const form = event.target;
    const button = event.submitter;
    try {
      // Also writes explicit No when the customer never touches the checkbox.
      await save();
      if (!form.isConnected || !button.isConnected) return;
      replay = true;
      form.requestSubmit(button);
    } catch (error) {
      showError(true);
      container.querySelector('[data-invoice-checkbox]')?.focus();
    } finally {
      replay = false;
      submitting = false;
      sync();
    }
  }, true);
})();
